// 一张卡里所有指向产品页的链接。换颜色时要一起改，快照/回滚也要一起管：
//   .card__cover-link  整卡覆盖层（标题、价格、空白那一片）
//   .card__slide-link  slider 模式下每个 swiper slide 上的链接（图片那一片）
// 少改一处的后果是同一张卡的标题和图片会去到不同颜色的页面。
// 放在文件顶层：下面的 checkSwatches 和文件末尾那个色块模块都要用，
// 写在某个 IIFE 里另一边就取不到（会 ReferenceError）。
const CARD_LINK_SEL = '.card__cover-link, .card__slide-link';

// 触屏浏览器不一定在按住链接期间保留 :active。只反馈封面链接，
// 不拦截点击或滚动；拖动、取消、松手和离开页面都立即释放。
function installCardTouchFeedback() {
  if (window.themeCardTouchFeedbackBound) return;
  window.themeCardTouchFeedbackBound = true;
  let pressed = null;
  const release = () => {
    if (pressed) pressed.card.classList.remove('card-touch-pressed');
    pressed = null;
  };
  document.addEventListener('pointerdown', (event) => {
    release();
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const link = event.target.closest(CARD_LINK_SEL);
    const card = link && link.closest('.card-wrapper');
    if (!card || event.target.closest('button, input, select, label, [role="button"], .colorItemBox')) return;
    pressed = { card, id: event.pointerId, x: event.clientX, y: event.clientY };
    card.classList.add('card-touch-pressed');
  }, { passive: true });
  document.addEventListener('pointermove', (event) => {
    if (pressed && event.pointerId === pressed.id && Math.hypot(event.clientX - pressed.x, event.clientY - pressed.y) > 8) release();
  }, { passive: true });
  document.addEventListener('pointerup', release, { passive: true });
  document.addEventListener('pointercancel', release, { passive: true });
  document.addEventListener('scroll', release, { passive: true, capture: true });
  document.addEventListener('visibilitychange', release);
  window.addEventListener('blur', release);
}
installCardTouchFeedback();

// 只固定即将移除的 auto 图片，避免脱离 DOM 后重新选择大图。
const removeCardImage = (img) => {
  if (img.sizes && /^auto(?:,|$)/.test(img.sizes.trim())) {
    const width = Math.round(img.getBoundingClientRect().width);
    if (width > 0) img.sizes = `${width}px`;
  }
  img.remove();
};

// 同页重复卡片共用在途请求；失败可重试，成功仅短期缓存。
const cardProductRequests = new Map();
const getCardProduct = (handle) => {
  const url = window.Shopify.routes.root + `products/${handle}.js`;
  const cached = cardProductRequests.get(url);
  if (cached && cached.expires > Date.now()) return cached.request;
  const request = jQuery.getJSON(url);
  const entry = { request, expires: Infinity };
  cardProductRequests.set(url, entry);
  request.done(() => { entry.expires = Date.now() + 30000; });
  request.fail(() => {
    if (cardProductRequests.get(url) === entry) cardProductRequests.delete(url);
  });
  // 限制长时间浏览时的缓存体积；已发出的请求不取消。
  if (cardProductRequests.size > 50) cardProductRequests.delete(cardProductRequests.keys().next().value);
  return request;
};

const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  // loading 必须在 src 之前设置，而且必须是 eager：这张图要在 DOM 之外解码完才插进来，
  // 而"先设 src 再设 loading=lazy"会让 Chromium 把已发起的请求撤回 —— 实测服务端
  // 一个请求都收不到，decode() 永远不 settle，换图根本不会发生。
  newImage.loading = "eager";
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.src = previewImage["src"];
  return newImage;
}

// 比较两个图片 URL 是否指向同一张图。必须按 pathname 比，不能直接比完整 src ——
// Liquid 渲染出来的图带 &width=750 之类的参数，产品 JSON 里的 preview_image.src 不带，
// 字符串永远不相等，点当前颜色也会重新下载再淡入一遍。
const samePath = (a, b) => {
  try {
    return new URL(a).pathname === new URL(b).pathname;
  } catch (e) {
    return a === b;
  }
}

// 等一张图真正能画出来。decode() 同时覆盖"还没加载完"和"加载完但还没解码"两种情况。
const whenPaintable = (img) => {
  if (typeof img.decode === 'function') return img.decode();
  // 已经有结论的图必须当场了结：complete 且 naturalWidth 为 0 说明它已经失败过了，
  // 这时再去等 error 事件是等不到的（早就派发完了），Promise 会永远挂着。
  if (img.complete) {
    return img.naturalWidth ? Promise.resolve() : Promise.reject(new Error('image failed'));
  }
  return new Promise((resolve, reject) => {
    img.addEventListener('load', resolve, { once: true });
    img.addEventListener('error', reject, { once: true });
  });
}

const checkSwatches = (root = document) => {
  const wrappers = Array.from(root.querySelectorAll('.js-color-swatches-wrapper'));
  if (root.matches?.('.js-color-swatches-wrapper')) wrappers.unshift(root);
  wrappers.forEach(wrapper => {
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      if (input.dataset.swatchBound) return; // 防重复绑定：load more 追加 / section load / colorSwatches 多次调用
      input.dataset.swatchBound = '1';
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          // 每次点击发一个递增令牌。连点时旧请求必须整条作废 —— 否则两次请求各插一张
          // 候选图，DOM 里会留下两张 media--first，显示的颜色跟色卡、链接、variant ID 对不上。
          const token = (wrapper.swatchToken = (wrapper.swatchToken || 0) + 1);
          const isStale = () => wrapper.swatchToken !== token;

          // 卡片上所有指向产品的链接都要跟着选中的颜色走，只更新其中一处不够：
          //  - hover 模式只有 .js-color-swatches-link 一个覆盖层；
          //  - slider 模式那个链接根本不渲染（product-card.liquid 的
          //    `{% if settings.on_hover != 'slider' %}`），改成每个 slide 各一个
          //    .card-wrapper__link--overlay，外层 .card-wrapper 本身还是个 <a>。
          // 原来只取 .js-color-swatches-link 且不判空，slider 下直接抛 TypeError，
          // 连同一个 handler 里的加购 variant ID 更新一起打断。
          // 注意作用域：覆盖层链接在源码里是 <a> 套 <a>（product-card.liquid 的
          // .card-wrapper 从 101 行开到 813 行，中间还有四个 <a>），HTML 不允许嵌套
          // 锚点，浏览器解析时会把内层提升成 .card-wrapper 的兄弟节点。线上真实 DOM
          // 实测：wrapper.querySelector('.js-color-swatches-link') 恒为 null，
          // 覆盖层和 .card-wrapper 同为 <li class="collection-product-card"> 的子元素。
          // 所以要从卡片的父容器里找。父容器里如果不止一张卡就退回 wrapper（等于找不到），
          // 宁可不更新，也不能把隔壁卡片的链接一起改掉。
          const variantLink = event.currentTarget.dataset.variantLink;
          if (variantLink) {
            if (wrapper.tagName === 'A') wrapper.setAttribute('href', variantLink);
            // 卡片里所有指向产品页的链接一起改（覆盖层 + slider 的 slide 链接）。
            // 这里原来写的是 .card-wrapper__link--overlay —— 那个元素 2026-08-31 已经
            // 从三个产品卡 snippet 里删掉了（它是 display:none，还会撑破外层 <a>），
            // 所以这段其实什么都没改到。
            wrapper.querySelectorAll(CARD_LINK_SEL).forEach((link) => {
              link.setAttribute('href', variantLink);
            });
          }
          // 选中的颜色没有可售变体时 data-variant-id 不输出（见 product-card-variant-options）。
          // 原来这里是无条件的：把加购按钮设为可用、隐藏 Sold out、再把 undefined 写进
          // input[name=id]，等于把一个不存在的变体推进加购流程。
          // 卡片上的色块不加 .disabled（那条 CSS 是 display:none，会让颜色整个消失），
          // 所以不可售的颜色仍然能选、能看、能跟着链接进产品页 —— 只是不能加购。
          const chosenVariantId = event.currentTarget.dataset.variantId;
          const addButton = wrapper.querySelector('.card__add-to-cart button[name="add"]');
          if (addButton) {
            const soldOut = !chosenVariantId;
            // product-form.js 只认 aria-disabled（第 24 行），原生 disabled 则连 click 都不派发，
            // 两个都设，跟 Liquid 首次渲染时的状态保持一致。
            addButton.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
            if (soldOut) {
              addButton.setAttribute('disabled', '');
            } else {
              // 原来只改 aria-disabled，不摘原生 disabled：首个变体售罄的产品即使换到
              // 有货颜色，按钮也一直是死的。
              addButton.removeAttribute('disabled');
            }
            // 只认 .card__quickview-text —— 按钮样式设成 link 时这个 span 根本不渲染，
            // 原来的 `> span` 会选中 .sold-out-message 本身，先摘 hidden 再加回去。
            const quickText = addButton.querySelector('.card__quickview-text');
            const soldOutMessage = addButton.querySelector('.sold-out-message');
            if (quickText) quickText.classList.toggle('hidden', soldOut);
            if (soldOutMessage) soldOutMessage.classList.toggle('hidden', !soldOut);

            const idInput = wrapper.querySelector('.card__add-to-cart input[name="id"]');
            if (idInput && chosenVariantId) idInput.value = chosenVariantId;
          }

          // ⚠ 这道守卫在当前 markup 下是够不着的，留着是为了 markup 修好之后能生效。
          //
          // product-card.liquid 的 .card-wrapper 是个 <a>，里面又嵌了 <a>（HTML 不允许）。
          // slider 模式的 slide 锚点在 171/189 行，排在色卡（503 行）之前，浏览器修复
          // 非法嵌套时会拆分并克隆外层 anchor，把后面的内容全部甩出 wrapper。
          // Chromium 实测：slider 形态下 wrapper.querySelectorAll('.js-color-swatches input')
          // 和 '.media--first' 都是 0，两个源码卡片被克隆成 8 个 wrapper。
          // 也就是说 slider 模式下监听根本绑不上，整个 handler 都进不来。
          //
          // 就算 markup 修好、能跑到这里，换图路径本身也没闭环：主图和 hover 图分处两个
          // swiper slide，跨 slide 替换/提升会把某个 slide 弄空，而且没有 slideTo(0) /
          // swiper.update()，用户停在别的 slide 上会看到空 slide 或旧图。
          // 所以这里只更新 variant / 加购 / 链接，不动图片。要真正支持 slider，
          // 得先拆掉嵌套锚点，再按"改第一张 slide 的图 + 切回 slide 0 + update"重做。
          if (wrapper.querySelector('.swiper.product-card-js')) return;

          const currentColor = event.currentTarget.value;

          getCardProduct(handleProduct).done(function(product) {
            if (isStale()) return;

            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
            if (!variant) return;

            const targetSrc = variant.featured_media.preview_image.src;
            if (samePath(targetSrc, primaryImage.src)) return;

            // 目标图就是现成的 hover 图：把它提上来当主图，不用再下一张。
            // 但要等它自己能画出来再删主图 —— hover 图是 lazy 的，未必已经加载完。
            if (secondaryImage) {
              if (secondaryImage.complete && secondaryImage.naturalWidth > 0 && samePath(secondaryImage.src, targetSrc)) {
                whenPaintable(secondaryImage).then(() => {
                  if (isStale()) return;
                  // 上一次换图可能已经把这两张清掉了。那种情况下放弃这条捷径，
                  // 保持现状 —— variant 链接和加购 ID 已经指向新颜色，仍然是对的。
                  if (!secondaryImage.parentElement || !primaryImage.parentElement) return;
                  const prevT = wrapper.activeSwatchTransition;
                  wrapper.activeSwatchTransition = {};
                  if (prevT && prevT.fade) prevT.fade.cancel();
                  removeCardImage(primaryImage);
                  secondaryImage.classList.remove('media--second');
                  secondaryImage.classList.add('media--first');
                  // 首图换人了，占位该不该摘，要重新判一次（原首图可能是张破图）
                  if (window.cardPlaceholder) window.cardPlaceholder.settle(secondaryImage);
                }, () => {
                  /* hover 图也加载不出来：保留主图，什么都不做 */
                });
                return;
              }
            }

            // 在 DOM 之外解码完成后才插入。解码期间绝不碰 .media —— 多一张 img 会让
            // :not(:only-of-type) 的 hover 规则立刻把主图设成 opacity 0（点色卡时卡片
            // 正处于 hover），单图产品直接空白，双图产品则被旧 hover 图盖住再跳变。
            const oldSizes = primaryImage.sizes;
            const measuredWidth = Math.ceil(primaryImage.getBoundingClientRect().width);
            // eager 候选图在 DOM 外无法使用 auto；非 auto 的裁切补偿表达式原样保留。
            const candidateSizes = /^auto(?:,|$)/.test(oldSizes.trim())
              ? (measuredWidth > 0 ? `${measuredWidth}px` : oldSizes.replace(/^auto\s*,?\s*/, '') || '100vw')
              : oldSizes;
            const newPrimaryImage = createImageElement(variant.featured_media, primaryImage.className, candidateSizes, product.title);
            whenPaintable(newPrimaryImage).then(() => {
              if (isStale()) return;

              const current = wrapper.querySelector('.media--first');
              if (!current || !current.parentElement) return;
              const media = current.parentElement;

              // 接管这张卡。令牌只能挡住"还没开始"的旧请求，挡不住"已经在跑"的旧动画收尾 ——
              // 上一次换图的 finish 仍然会触发，得靠这张所有权凭证让它认出自己已经不是当前那次。
              // 先易主再取消，顺序反了旧 finish 可能还以为自己是当前的。
              const prev = wrapper.activeSwatchTransition;
              const transition = {};
              wrapper.activeSwatchTransition = transition;
              if (prev && prev.fade) prev.fade.cancel();

              // 旧 hover 图属于旧颜色，连同上一轮可能残留的候选图一起清掉，只留 current
              // 垫在底下：它们要么会盖在新图上面，要么留在 DOM 里变成脏数据。
              // secondaryImage 在 swiper 分支里位于另一个 slide，单独点名删。
              if (secondaryImage && secondaryImage.parentElement) removeCardImage(secondaryImage);
              media.querySelectorAll('img').forEach((img) => {
                if (img !== current) removeCardImage(img);
              });

              // inline 样式压住 hover 规则：插入新图后 current 不再是 :only-of-type，
              // 样式表会把它设成 opacity 0，那样淡入期间底下就是空的。
              current.style.opacity = '1';
              newPrimaryImage.style.opacity = '0';
              current.after(newPrimaryImage);
              // 插入后恢复响应式尺寸，避免旋转屏幕/调整窗口后仍固定为旧宽度。
              if (/^auto(?:,|$)/.test(oldSizes.trim())) {
                newPrimaryImage.loading = 'lazy';
                newPrimaryImage.sizes = oldSizes;
              }

              const fadeIn = newPrimaryImage.animate(
                { opacity: [0, 1] },
                { duration: 200, easing: "ease-in", fill: "forwards" }
              );
              transition.fade = fadeIn;
              const finish = () => {
                // 第一件事就是确认所有权，必须排在任何 DOM 删除之前。放到 current.remove()
                // 后面就晚了 —— 更新的那次换图已经把同一张 current 当成自己的底图，
                // 删掉它会让新的淡入中途露出透明背景，正是这次要消灭的那种闪烁。
                if (wrapper.activeSwatchTransition !== transition) {
                  fadeIn.cancel();
                  removeCardImage(newPrimaryImage);
                  return;
                }
                removeCardImage(current);
                // 先清 inline 再 cancel：反过来的话 inline 的 0 会接管，闪一下不可见。
                // 必须 cancel，否则 fill: forwards 一直压着 opacity，之后 hover 换图就动不了。
                newPrimaryImage.style.opacity = '';
                fadeIn.cancel();
                media.querySelectorAll('img').forEach((img) => {
                  if (img !== newPrimaryImage) removeCardImage(img);
                });
                // 新图是在文档外加载的，load 事件路径里没有 document，
                // card-placeholder.js 的捕获监听看不到，插入后也不补发 load，只能主动补一次
                if (window.cardPlaceholder) window.cardPlaceholder.settle(newPrimaryImage);
              };
              if (fadeIn && fadeIn.finished) {
                fadeIn.finished.then(finish, finish);
              } else {
                setTimeout(finish, 200);
              }
            }, () => {
              // 新图加载/解码失败：丢掉候选图，保留原来那张。破图不传达任何颜色信息，
              // 还把本来能看的产品图弄没了 —— 比留着旧颜色更糟。variant 链接和加购 ID
              // 已经指向新颜色，用户点进去仍然是对的。
            });
          });
        }
      })
    })
  })
}

/* =====================================================================
   hover 第二张图的延迟挂载 —— 配合 snippets/product-card.liquid

   那边把 media--second 的 src / srcset / sizes 收进了 data-*，这里负责还原。
   只在 min-width:990px 还原：揭示这张图的 CSS（product-card.css、
   component-card.css、component-card-extended.css、
   section-joint-cooperation-products.css 的 `:hover … > img + img`）
   全部在 @media (min-width: 990px) and (hover: hover) and (pointer: fine) 里，
   990 以下 base.css 的 `.media.media--hover-effect > img + img { opacity: 0 }`
   恒生效，下下来也看不到。首页 iPhone 视口实测白下 1.43MB / 21 张。

   只认带 data-src 的。productcolor-card.liquid 和
   product-card-visualization-tool.liquid 各有一份自己的卡片模板，
   没走这套 data-*，不会被这里碰到。
   ===================================================================== */
// 这个断点存在的唯一理由是**跟 CSS 对齐**，不是在用宽度推断用户有没有鼠标。
// 不变式：hydrate 的条件必须是 CSS 揭示条件的超集 —— CSS 能让这张图露出来的
// 任何情况下，它都必须已经有 src，否则 hover 会淡出成空白。
// 揭示条件现在写死在四个文件的
// @media (min-width: 990px) and (hover: hover) and (pointer: fine) 里
// （product-card.css / component-card.css / component-card-extended.css /
// section-joint-cooperation-products.css），这里只取其中的宽度。
// CSS 多出的 hover/pointer 只会让揭示范围更窄，不变式照样成立；
// 代价是 iPad 横屏这类 ≥990 的触屏设备会 hydrate 一张露不出来的图（2026-10-11 起）。
// 这里也换成同一条完整查询同样满足不变式（有下面的 pointerover 委托兜底），
// 能省掉 iPad 横屏这份流量；暂未改，是为了不在动效改动里顺带动下载行为。
// **改 CSS 的那个断点（990），必须同时改这里；四个文件的媒体查询也要保持一致。**
//
// 为什么不用 (any-hover: hover) and (any-pointer: fine) 来"解耦输入能力"：
// 那个查询在触屏手机上会假阳性。Samsung 自 2015 年起所有机型（外加 OnePlus 等
// 部分 OEM）在系统里挂了一个虚拟鼠标设备，Chromium 系浏览器据此报
// hover:hover / pointer:fine；any-* 取的是所有输入设备的并集，只会更容易命中。
// 这个缺陷至今没修。用它当门槛，等于在 Samsung 用户身上把这次省下的流量原样退回去，
// 而且如果 CSS 也跟着改，这些手机上一 tap 就会触发 :hover 换图。
// 本文件下面那段色块逻辑已经为同一个问题栽过一次（见 lastPointerType 那段注释：
// 第一版用 matchMedia('(hover: hover) and (pointer: fine)')，
// 带触屏的 Windows 笔记本因为有触控板恒为 true）。
// 输入能力只能靠**真实事件的 pointerType** 判定，不能靠媒体查询 —— 见下面那条委托。
const hoverImageMQ = window.matchMedia('(min-width: 990px)');

// sizes 必须比 srcset 先设。反过来的话浏览器会先按缺省的 100vw 选一次档，
// 白下一张大得多的图，等 sizes 到位已经晚了。
const hydrateHoverImage = (img) => {
  if (!img || img.dataset.src === undefined) return;
  if (img.dataset.sizes !== undefined) {
    img.setAttribute('sizes', img.dataset.sizes);
    delete img.dataset.sizes;
  }
  if (img.dataset.srcset !== undefined) {
    img.setAttribute('srcset', img.dataset.srcset);
    delete img.dataset.srcset;
  }
  img.setAttribute('src', img.dataset.src);
  delete img.dataset.src;
};

function hydrateHoverImages(root) {
  if (!hoverImageMQ.matches) return;
  (root || document).querySelectorAll('img.media--second[data-src]').forEach(hydrateHoverImage);
}

// 跨过断点（旋转屏幕 / 拉窗口）后把刚变得可见的那批补上
if (hoverImageMQ.addEventListener) {
  hoverImageMQ.addEventListener('change', () => hydrateHoverImages());
} else if (hoverImageMQ.addListener) {
  hoverImageMQ.addListener(() => hydrateHoverImages());
}

// 兜底：真的有鼠标/触控笔移到卡片上，就把这张卡的 hover 图补齐。
//
// 两个作用：
// 1. 补插卡路径。colorSwatches() 覆盖了已知的几条（facets / load-more /
//    predictive-search / global / shopify:section:load），但任何一条以后新增的、
//    忘了调 colorSwatches() 的路径，都会让那张卡 hover 时淡出成空白。
// 2. 兜住"上面那个断点和 CSS 不同步"的情况。哪天 CSS 的揭示条件改成按输入能力
//    （any-hover 之类），或者断点从 990 挪走而这里忘了跟，这条委托仍然能在
//    用户真的悬停到卡片的那一刻把图补上，不变式不会整条塌掉。
//
// 判定输入方式用 event.pointerType，不用媒体查询：pointerType 报的是**产生这个
// 事件的那个设备**，手指点出来的是 'touch'，所以 Samsung 那个虚拟鼠标
// 污染不到它（实测一次 tap 依次产生 pointerdown:touch → touchstart → mousedown →
// click:touch，见下面色块那段）。媒体查询报的是设备"有没有"某种能力，
// 两者在混合输入设备上结论完全不同。
// 没有 Pointer Events 的老浏览器退回断点判断。
document.addEventListener(
  'PointerEvent' in window ? 'pointerover' : 'mouseover',
  (event) => {
    if ('PointerEvent' in window) {
      if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
    } else if (!hoverImageMQ.matches) {
      return;
    }
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const card = target.closest('.card-wrapper, .collection-product-card, .collection-hero__product-card');
    if (!card) return;
    hydrateHoverImage(card.querySelector('img.media--second[data-src]'));
  },
  { passive: true, capture: true }
);

function colorSwatches(root = document) {
  checkSwatches(root);
  // 和 checkSwatches 挂在同一个入口：facets.js / load-more.js /
  // predictive-search.js / global.js 追加卡片后调的都是 colorSwatches()。
  hydrateHoverImages(root);
}

// 只绑一次：否则每次 AJAX 筛选刷新都会再 addEventListener，全局监听器会越积越多
document.addEventListener('shopify:section:load', function (event) {
  colorSwatches(event.target);
});

(function () {
  colorSwatches();
})();

/* =====================================================================
   卡片色块（.colorList[data-colors="v2"]）—— 2026-08-28

   接管 snippets/product-card.liquid 里原本每张卡一份的内联 <script>。
   那份脚本在 custom-curtains 集合页有 111 个拷贝，占整页 212KB / 10.8%；
   首页 41KB、blackout-curtains 59KB。改成 document 级事件委托后归零，
   顺带解决了它三个问题：mediaSecond 不判空（单图产品 hover 抛 TypeError）、
   click 走 window.open('_blank')、以及下面注释里说的换图慢。

   只认 data-colors="v2"。productcolor-card.liquid 和
   product-card-visualization-tool.liquid 仍带着各自的旧内联脚本，
   它们的 .colorList 没有这个标记，不会被这里接管，避免同一个色块绑两次。
   ===================================================================== */
;(function () {
  const LIST_SEL = '.colorList[data-colors="v2"]';
  const BOX_SEL = '.colorItemBox';

  // 分流按「本次输入」，不是按设备。
  //
  // 第一版用 matchMedia('(hover: hover) and (pointer: fine)') 判断，那问的是设备的
  // 主指针：Surface / 带触屏的 Windows 笔记本因为有触控板，matches 恒为 true，
  // 用户用手指点色块也会走桌面分支直接跳走 —— 跟"触屏就地换图"的目标正好相反。
  // 现在用 Pointer Events：hover 那条路只认 pointerType === 'mouse'，
  // click 用最近一次 pointerdown 的 pointerType 决定走哪边。
  // 触控笔（pen）按触屏处理：用户拿笔戳色块，期待的也是就地换图。
  const hasPointerEvents = 'PointerEvent' in window;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  // 只在浏览器既没有 Pointer Events、事件上也读不到 pointerType 时，才退回设备级判断
  let lastPointerType = fine.matches ? 'mouse' : 'touch';

  // click 在 Chromium/Firefox 里本身就是 PointerEvent，自带 pointerType，直接读最准；
  // Safari 的 click 仍是 MouseEvent，读不到就退回最近一次 pointerdown 记下的值。
  // 实测（Playwright 触屏上下文）：一次 tap 依次产生
  // pointerdown:touch → touchstart → mousedown → click:touch，两条路都能拿到 touch。
  const isMouseInput = (event) => {
    // 键盘激活（Enter / 空格）产生的 click：detail === 0 且没有 pointerType。
    // 不能退回"最近一次指针类型" —— 手机外接键盘、或 Surface 刚用过触摸之后，
    // 那个值是 touch，会把回车当成触屏点击、preventDefault 掉，链接就跳不动了。
    // 键盘按下去的语义就是"激活这个链接"，按鼠标那条路走。
    if (event && event.detail === 0 && !event.pointerType) return true;
    const t = event && event.pointerType;
    if (t) return t === 'mouse';
    if (hasPointerEvents) return lastPointerType === 'mouse';
    return fine.matches;
  };
  const isMouseEvent = (event) =>
    hasPointerEvents ? event.pointerType === 'mouse' : fine.matches;

  const closest = (node, sel) => (node && node.closest ? node.closest(sel) : null);
  const swatchBox = (node) => {
    const box = closest(node, BOX_SEL);
    return box && box.closest(LIST_SEL) ? box : null;
  };

  // 色块 2026-08-31 从 <div data-href> 改成了 <a href>。读 href 优先，
  // data-href 兜底（万一还有没改过来的卡片 snippet）。
  const swatchHref = (box) => box.getAttribute('href') || box.dataset.href || '';

  // 解析色块所属的卡片。
  //
  // 正常情况 .colorList 就在 .card-wrapper 里，closest 直接命中。但 .card-wrapper
  // 本身是个 <a>，而 slider 模式（settings.on_hover == 'slider'）会在色块之前再输出
  // slide 内的 <a>，show_size_count + product_size_option_display == 'value' 也会。
  // HTML 不允许 <a> 套 <a>：浏览器提前闭合外层并克隆它，**每多一个内层 <a> 就多一个克隆**。
  // 用真实文档解析器实测：内层只有 slide 锚点时解析出 2 个 .card-wrapper，
  // 再加上 .card-wrapper__link--overlay 就是 3 个。共同点是排在前面的都是空壳（没有图），
  // 而 .colorList 被甩成 <li> 的直接子元素，closest('.card-wrapper') 返回 null。
  // 那种形态下 hover、点击、改链接会三条路一起静默失效。
  // 当前 settings.on_hover 是 'hover'、product_size_option_display 为空，所以没触发；
  // 这段兜底是为了运营改配置时不回归。根治办法是把 .card-wrapper 从 <a> 换成 div，
  // 那要动 16 个 section 和大量 .card-wrapper 样式，单独开项。
  // 返回这个色块相关的所有 .card-wrapper（克隆形态下不止一个），带图的排在最前。
  // 改 href 要改全部克隆 —— 只改一个的话，用户点到另一个克隆仍然是旧链接。
  const cardsFor = (box) => {
    const list = closest(box, LIST_SEL);
    const direct = closest(box, '.card-wrapper');
    // direct 命中也可能是个空壳（理论上空壳里不会有色块，但别赌）：没图就继续走搜索
    if (direct && direct.querySelector('img.media--first')) return [direct];

    const handle = list && list.dataset.product;
    if (!handle) return direct ? [direct] : [];
    const sel =
      '.card-wrapper[data-product="' +
      (window.CSS && CSS.escape ? CSS.escape(handle) : handle.replace(/"/g, '\\"')) +
      '"]';

    let scope = list.parentElement;
    while (scope) {
      const found = Array.prototype.slice.call(scope.querySelectorAll(sel));
      if (found.length) {
        // 克隆出来的空壳排在前面，带图的那个才是真正的卡
        found.sort((a, b) => (b.querySelector('img.media--first') ? 1 : 0)
                           - (a.querySelector('img.media--first') ? 1 : 0));
        return found;
      }
      scope = scope.parentElement;
    }
    return direct ? [direct] : [];
  };

  const findCard = (box) => cardsFor(box)[0] || null;

  // slider 形态下主图和 hover 图分处不同 swiper slide，跨 slide 换图会把某个 slide
  // 弄空，而且没有 slideTo(0) / swiper.update()，用户停在别的 slide 上会看到旧图。
  // 和本文件上面那段判断保持一致：这种卡只更新链接，不动图片。
  // 两个方向都要查：正常形态 swiper 在卡里面；克隆形态下卡有可能反过来落在 swiper 里。
  const canSwapImage = (card) =>
    !card.querySelector('.swiper.product-card-js') && !card.closest('.swiper.product-card-js');

  // 提前起跑：手指按到色块（touchstart）比 click 早 ~100ms，先把图请求发出去。
  // 用高优先级 —— 用户已经摸上去了，这不是投机加载。
  //
  // 这里刻意"不"做卡片进视口/鼠标进卡片时的批量预取。试过一版：鼠标进卡片就用
  // fetchPriority='low' 预取该卡的 4 张图，结果反而更慢 —— 用户真的悬停到色块时，
  // 那个低优先级请求已经在途，Chromium 不会把在途请求提级，高优先级的探测图只能
  // 排在它后面。同页实测：不预取 918ms / 低优先级预取 4 张 1326ms，
  // 而挂到真实卡片上跑时后者超过 6 秒。
  const warmed = new Set();
  const warm = (url) => {
    if (!url || warmed.has(url)) return;
    warmed.add(url);
    const im = new Image();
    im.decoding = 'async';
    if ('fetchPriority' in im) im.fetchPriority = 'high';
    im.src = url;
  };

  // 触屏按下时的提前起跑。data-touch="navigate" 的色块触屏根本不换图（现在全站都是），
  // 预下载纯属浪费移动端流量。
  // pointerdown 和 touchstart 两个入口都要判：支持 Pointer Events 的手机
  // （iPhone / 现代 Android）先派发 pointerdown，只在 touchstart 上拦等于没拦，
  // 图早就下下去了。
  const warmSwatch = (box) => {
    if (!box) return;
    const list = box.closest(LIST_SEL);
    if (list && list.dataset.touch === 'navigate') return;
    warm(swatchImageUrl(box));
  };

  // 预热与正式换图必须使用同一 URL，按实际槽位和 DPR 选档。
  const swatchImageUrl = (box) => {
    const url = box && box.dataset.src;
    if (!url) return url;
    const card = findCard(box);
    const img = card && (card.querySelector('img.media--second') || card.querySelector('img.media--first'));
    if (!img) return url;
    const rect = img.getBoundingClientRect();
    if (!rect.width) return url;
    const naturalWidth = Number(box.dataset.imageWidth);
    const naturalHeight = Number(box.dataset.imageHeight);
    let width = rect.width;
    if (getComputedStyle(img).objectFit === 'cover' && naturalWidth > 0 && naturalHeight > 0) {
      width = Math.max(width, rect.height * naturalWidth / naturalHeight);
    }
    const needed = Math.ceil(width * (window.devicePixelRatio || 1));
    const selected = [360, 533, 720, 940, 1066, 1440, 1800, 2400].find(w => w >= needed) || needed;
    try {
      const source = new URL(url, document.baseURI);
      source.searchParams.set('width', String(Math.min(selected, naturalWidth || 720)));
      return source.href;
    } catch (_) { return url; }
  };

  // 记原图供还原。必须连 srcset 一起记：只还原 src 的话 srcset 会继续赢，图换不回去。
  const remember = (img) => {
    if (img.dataset.swatchOrigSrc === undefined) {
      img.dataset.swatchOrigSrc = img.getAttribute('src') || '';
      img.dataset.swatchOrigSrcset = img.getAttribute('srcset') || '';
    }
  };

  // 换成按当前槽位选好的定尺寸图，并显式清空 srcset。
  // 不清空的话浏览器仍按旧 srcset 选图，src 形同虚设 —— 旧实现就是重建一条
  // 360~1800 的 srcset，配上模板里那条非法的 sizes（`535px * 1` 不是合法长度，
  // 浏览器丢弃后退回 100vw 量级的 calc），实测 328px 的槽位挑到了 ?width=940 = 232KB。
  const applyImage = (img, url) => {
    img.setAttribute('srcset', '');
    img.setAttribute('src', url);
  };

  const restoreImage = (img) => {
    if (img.dataset.swatchOrigSrc === undefined) return;
    img.setAttribute('srcset', img.dataset.swatchOrigSrcset);
    img.setAttribute('src', img.dataset.swatchOrigSrc);
  };

  // 解码完成再上屏。旧实现直接改 DOM 里那张 loading="lazy" 的 img 的 src，
  // 实测 8 次 hover 只有 1 次在 15 秒内画出来（4.9s），其余要么 naturalWidth 恒为 0、
  // 要么浏览器保留旧帧一动不动 —— 两种在用户眼里都是"hover 没反应"。
  //
  // 主因是请求优先级，不是图大。同一个 URL、同一个页面里实测：
  //   fetch()                              626ms
  //   new Image() 默认优先级               16.0s
  //   new Image() + fetchPriority='high'    1.0s
  // 集合页有几十个第三方脚本在抢带宽，图片默认那档优先级会被一直往后排。
  // 所以这里必须显式 high：用户已经把指针放上去了，这不是投机加载。
  //
  // 令牌用于作废在途的旧请求：连着划过几个色块时，先发的可能后到。
  //
  // 返回 'ok' / 'failed' / 'stale'，**三态必须分开**。之前只返回 true/false，
  // 过期请求和加载失败都是 false，调用方分不清，导致这个时序 bug：
  //   点 A（请求1）→ 图还没到位又点 A（请求2）→ 请求1 判定过期返回 false
  //   → 调用方当成"加载失败"，把请求2 刚设好的选中态和 href 回滚掉
  //   → 请求2 随后换图成功，但选中态和链接已经退回默认色。
  // A→B→A 快速连点同理。'stale' 必须什么都不做。
  //
  // is-loading 的清除也归本次请求管：过期请求直接清会把新请求的 loading 提前抹掉。
  // 但不能简单地"过期就不清" —— 换到另一个色块时旧色块会永远留着 loading。
  // 所以按 box 记 token，只有写上去的那次有资格清。
  const swapImage = (card, img, url, box) =>
    new Promise((resolve) => {
      if (!img || !url) {
        resolve('failed');
        return;
      }
      const token = (card.__swatchToken = (card.__swatchToken || 0) + 1);
      const stale = () => card.__swatchToken !== token;

      if (box) {
        box.__loadToken = token;
        box.classList.add('is-loading');
      }

      const probe = new Image();
      probe.decoding = 'async';
      if ('fetchPriority' in probe) probe.fetchPriority = 'high';
      probe.src = url;

      let settled = false;
      let timer;
      const done = (status) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        probe.removeEventListener('load', paint);
        probe.removeEventListener('error', giveUp);
        if (box && box.__loadToken === token) box.classList.remove('is-loading');
        resolve(status);
      };
      const paint = () => {
        if (settled) return; // 超时后的 decode/load 不能覆盖已回滚或更新的选择。
        if (stale()) {
          done('stale');
          return;
        }
        remember(img);
        applyImage(img, url);
        done('ok');
      };
      // 目标图加载失败就保持原样。破图不传达任何颜色信息，
      // 比留着旧颜色更糟 —— 和本文件上面换图逻辑的取舍一致。
      const giveUp = () => done(stale() ? 'stale' : 'failed');

      timer = setTimeout(giveUp, 15000);

      if (typeof probe.decode === 'function') probe.decode().then(paint, giveUp);
      else if (probe.complete) (probe.naturalWidth ? paint : giveUp)();
      else {
        probe.addEventListener('load', paint, { once: true });
        probe.addEventListener('error', giveUp, { once: true });
      }
    });

  /* ---------- 鼠标悬停色块换 hover 图 ---------- */

  // 用 pointerover/pointerout 而不是 pointerenter/leave：后者不冒泡，没法做委托。
  // 没有 Pointer Events 的浏览器退回 mouseover/mouseout。
  const onPointerEnter = (event) => {
    if (!isMouseEvent(event)) return;
    const box = swatchBox(event.target);
    if (!box) return;
    const card = findCard(box);
    if (!card || !canSwapImage(card)) return;
    // 单图产品没有 media--second。旧实现在这里直接 setAttribute，必抛 TypeError。
    const img = card.querySelector('img.media--second');
    // 鼠标已经悬上来了，无论视口多宽这张图都该有 src ——
    // 混合输入设备（带鼠标的触屏本）可能在 990 以下走到这里，那时 hydrateHoverImages()
    // 还没补过。不补的话 remember() 会把空字符串记成"原图"，
    // 移开鼠标时 restoreImage() 设 src=""，浏览器会去请求当前页面地址。
    if (img) hydrateHoverImage(img);
    if (img) swapImage(card, img, swatchImageUrl(box), box);
  };

  const onPointerLeave = (event) => {
    if (!isMouseEvent(event)) return;
    const box = swatchBox(event.target);
    if (!box) return;

    // 在同一排色块之间横向移动时不要还原，否则每挪一格都要闪一下原图。
    const to = swatchBox(event.relatedTarget);
    if (to && to.closest(LIST_SEL) === box.closest(LIST_SEL)) return;

    const card = findCard(box);
    if (!card) return;
    card.__swatchToken = (card.__swatchToken || 0) + 1; // 作废在途换图
    // 顺手把 loading 态摘掉：在途请求已经作废，它自己不会再来清（清除受 __loadToken
    // 保护）。不摘的话图迟迟不回来时色块会一直半透明挂着。
    box.classList.remove('is-loading');
    const img = card.querySelector('img.media--second');
    if (img) restoreImage(img);
  };

  document.addEventListener(hasPointerEvents ? 'pointerover' : 'mouseover', onPointerEnter, {
    passive: true,
  });
  document.addEventListener(hasPointerEvents ? 'pointerout' : 'mouseout', onPointerLeave, {
    passive: true,
  });

  /* ---------- 记录本次输入方式，顺便让触屏提前起跑 ---------- */
  // capture 阶段登记，免得被别人的 stopPropagation 挡掉 —— 记错输入方式会让
  // 下面的 click 走错分支，代价比漏一次预热大。
  if (hasPointerEvents) {
    document.addEventListener(
      'pointerdown',
      (event) => {
        if (event.pointerType) lastPointerType = event.pointerType;
        if (event.pointerType === 'mouse') return;
        // 手指按下比 click 早 ~100ms，先把图请求发出去
        warmSwatch(swatchBox(event.target));
      },
      { passive: true, capture: true }
    );
  }
  // 无论有没有 Pointer Events 都听一遍 touchstart：老浏览器只有 TouchEvent，
  // 新浏览器多记一次也无害（pointerdown 已经记过同样的值）。
  document.addEventListener(
    'touchstart',
    (event) => {
      lastPointerType = 'touch';
      warmSwatch(swatchBox(event.target));
    },
    { passive: true, capture: true }
  );

  /* ---------- 点击 ---------- */
  // 必须注册在**捕获阶段**，冒泡阶段不行。
  //
  // 站上另有一方会在 click 之后按卡片 href 主动导航。监听挂在冒泡阶段时实测
  // （iPhone 13 / 触屏笔记本）：
  //   pointerdown:touch → touchstart → pointerup:touch → touchend → mousedown
  //   → mouseup → click(defaultPrevented=true) → beforeunload
  // 也就是 preventDefault 明明生效了，页面还是跳走。而且它用的是我们刚改过的那个
  // href，落地 URL 还带着 selectcolor，看起来"像是"桌面分支干的，排查时极易被带偏。
  //
  // 挪到捕获阶段后同样的操作不再跳走，而且 click 依旧完整跑完冒泡阶段
  // （冒泡监听照样收到 def:true）。说明那一方**是尊重 defaultPrevented 的**，
  // 只是原来我们跑得比它晚，它读到的还是 false。
  // 所以这里不需要 stopPropagation / stopImmediatePropagation —— 掐传播会顺手
  // 掐掉 click-data 埋点、热图和卡片自己的监听，代价不必付。
  // 把整卡链接指向某个颜色。克隆形态下不止一个 .card-wrapper，要全改，
  // 只改一个的话用户点到另一个克隆仍然是旧链接。返回改动前的 [卡, href] 快照。
  const setCardHref = (cards, href) => {
    const prev = [];
    cardLinks(cards).forEach((a) => {
      prev.push([a, a.getAttribute('href')]);
      if (href) a.setAttribute('href', href);
    });
    return prev;
  };

  // 一张卡里所有指向产品页的链接，换颜色时要一起改，快照/回滚也要一起管：
  //   .card__cover-link  整卡覆盖层（标题、价格、空白那一片）
  //   .card__slide-link  slider 模式下每个 swiper slide 上的链接（图片那一片）
  // 少改一处的后果是同一张卡的标题和图片会去到不同颜色的页面。
  // 卡片自己是 <a> 的老形态也照样认（还没改过来的 snippet）。
  const cardLinks = (cards) => {
    const out = [];
    cards.forEach((c) => {
      if (c.tagName === 'A') out.push(c);
      c.querySelectorAll(CARD_LINK_SEL).forEach((a) => out.push(a));
    });
    return out;
  };

  const snapshotHrefs = (cards) =>
    cardLinks(cards).map((a) => [a, a.getAttribute('href')]);

  // 把某一排色块和整卡链接恢复到"已落实"的那个状态
  const applyCommitted = (list, boxes) => {
    const c = list.__committed;
    if (!c) return;
    boxes.forEach((b) => {
      const on = b === c.box;
      b.classList.toggle('is-selected', on);
      if (on) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });
    c.hrefs.forEach((pair) => {
      if (pair[1] !== null) pair[0].setAttribute('href', pair[1]);
    });
  };

  document.addEventListener('click', (event) => {
    const box = swatchBox(event.target);
    if (!box) return;
    const cards = cardsFor(box);
    const card = cards[0];
    if (!card) return;

    // 有些色块的目标是"去另一个页面"而不是"选个颜色"（可视化工具页链接进
    // /pages/visualized-tool-v2）。那种情况下触屏也应该直接跳，就地换图没有意义 ——
    // 由 Liquid 在 .colorList 上打 data-touch="navigate"。
    const list0 = box.closest(LIST_SEL);
    const touchNavigates = list0 && list0.dataset.touch === 'navigate';

    if (isMouseInput(event) || touchNavigates) {
      // 鼠标（或上面那种"色块即跳转"的配置）：色块本身就是 <a href>，
      // **什么都不做**，让浏览器原生跳转。
      // 这样 Ctrl/Cmd+点击开新标签、中键、右键复制链接全都照常。
      // 旧实现是 preventDefault + window.location.assign，把这些能力全挡掉了
      // （更早的版本甚至是 window.open('_blank')，直接把人从列表里弹走）。
      // 只把整卡链接同步成同一个目标：万一后面还有别的监听按卡片 href 再导航一次，
      // 它读到的地方和我们要去的一致，不会把用户送回默认颜色。
      setCardHref(cards, swatchHref(box));
      return;
    }

    // 触屏/触控笔：拦掉跳转，改成就地换主图；卡片其它位置照常进产品页。
    // 刻意不掐传播（不 stopPropagation），理由见上面那段注释。
    event.preventDefault();

    const list = list0;
    const boxes = Array.prototype.slice.call(list.querySelectorAll(BOX_SEL));
    let prevSelected = null;
    for (let i = 0; i < boxes.length; i += 1) {
      if (boxes[i].classList.contains('is-selected')) prevSelected = boxes[i];
    }

    // 这一次选择的编号。只有最新一次点击有资格回滚 —— 否则连点同一个色块时，
    // 先发的那次请求会把后一次刚设好的状态擦掉（详见 swapImage 上面的说明）。
    const selToken = (list.__selToken = (list.__selToken || 0) + 1);

    // 先给反馈：手指点下去要立刻有回应，不能等 1~3 秒的图。
    boxes.forEach((b) => {
      const on = b === box;
      b.classList.toggle('is-selected', on);
      // 选中态要同步给读屏，光有 class 不够。色块是 <a>，所以用 aria-current
      // （aria-pressed 只对 button 有效）。
      if (on) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });

    // 选完颜色后整卡链接跟着走这个颜色，否则点进去还是默认色，
    // 用户会以为刚才那一下没生效。
    // 改的是 .card__cover-link（整卡唯一的链接）。老形态里 .card-wrapper 自己是 <a>
    // 的也一并改，见 cardLinks()。
    const prevHrefs = setCardHref(cards, swatchHref(box));

    // "已落实"的选择 = 最后一次真的换图成功的那个颜色。
    // 回滚必须回到它，**不能回到点击瞬间的 DOM** —— 那个 DOM 可能只是上一次点击的
    // 乐观显示，而它的换图请求早已被作废。反例：点 A（图还在下）→ 点 B（A 的请求判过期）
    // → B 加载失败 → 若按点击瞬间的 DOM 回滚就回到 A，可是 A 从没换图成功，
    // 最终变成"色块和链接是 A、主图还是默认色"。
    // 第一次交互时用点击前的真实状态初始化，之后只有成功才更新。
    if (!list.__committed) list.__committed = { box: prevSelected, hrefs: prevHrefs };

    // slider 形态换不了图，链接更新本身就是最终结果，直接算落实。
    if (!canSwapImage(card)) {
      list.__committed = { box: box, hrefs: snapshotHrefs(cards) };
      return;
    }

    // 触屏换的是 media--first：没有 hover，media--second 的 opacity 恒为 0，
    // 换它等于什么都没发生。
    swapImage(card, card.querySelector('img.media--first'), swatchImageUrl(box), box)
      .then((status) => {
        // 已经有更新的一次点击接管了，什么都别碰，交给它管
        if (list.__selToken !== selToken) return;

        if (status === 'ok') {
          list.__committed = { box: box, hrefs: snapshotHrefs(cards) };
          return;
        }

        // failed 和 stale 都要回到"已落实"的状态。
        //
        // stale 在这里**不能当作"保持现状"**：能走到这一行说明本次仍是最新的选择，
        // 那么作废它的就不是另一次点击（那种情况上面 selToken 那道守卫已经拦掉），
        // 而是非选择路径 —— 混合输入设备上鼠标掠过同一张卡的色块时，
        // onPointerEnter / onPointerLeave 都会推进 card.__swatchToken。
        // 此时这次触屏选择从未落实：不回滚就会留下
        // "色块和链接是 A、主图还是 committed 的颜色"这种自相矛盾的状态。
        applyCommitted(list, boxes);
      });
  }, { capture: true });
})();

/* =====================================================================
   卡片动图 / 视频 —— 配合 snippets/product-card-motion.liquid

   动图层叠在首图上、默认透明。2026-10-16 业主更新：按商品元字段播放完整遍数，
   留空为 3，正整数为指定次数，0 为无限循环；不放播放/暂停按钮，不再限制 5 秒。
   此设计不再使用 WCAG 2.2.2 的 5 秒豁免（业主已确认无控件取舍）。
   - 临近视口（300px）才挂源，真正可见（≥25%）才播；滚出停下，再进入重新计数。
   - 视频出了第一帧（playing）才加 .is-ready；加载、拒绝播放时始终显示首图。
   - 只支持视频；完成指定遍数后停在静帧并淡回首图。
   - 进度看门狗只处理 playing 后时间不再前进的冻结，不限制正常播放的总时长。
   - 系统「减少动效」或省流量模式不挂源；系统拒绝自动播放时本轮保持首图。
   - 切到后台停播；桌面悬停让位第二张图，移开接着播，不重置计数。
   - 用户选色撤掉视频，不盖住所选颜色。
   新卡片（筛选 innerHTML 整块替换、load more、搜索弹窗、主题编辑器 section:load）
   一律由 MutationObserver 发现，不依赖各条插卡路径记得调用；脱离文档的卡同时回收。
   ===================================================================== */
(function () {
  if (window.themeCardMotion) return;

  const ROOT_SEL = '[data-card-motion]';
  const DEFAULT_PLAY_COUNT = 3;
  const STALL_MS = 3000;
  const playCount = (raw) => {
    const value = String(raw == null ? '' : raw).trim();
    const count = Number(value);
    return /^\d+$/.test(value) && Number.isSafeInteger(count) ? count : DEFAULT_PLAY_COUNT;
  };
  const mq = (query) =>
    window.matchMedia ? window.matchMedia(query) : { matches: false, addEventListener() {} };
  const reduceMQ = mq('(prefers-reduced-motion: reduce)');
  // 与 CSS 揭示 hover 第二张图的条件一致
  const hoverMQ = mq('screen and (min-width: 990px) and (hover: hover) and (pointer: fine)');
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const allowed = () => !(reduceMQ.matches || saveData);

  const items = new Map(); // root -> state
  let nearIO = null;
  let viewIO = null;

  // 卡片需要的视频像素宽 = CSS 宽度 × 像素比（上限 2）
  const neededWidth = (it) =>
    (it.root.getBoundingClientRect().width || 0) * Math.min(window.devicePixelRatio || 1, 2);

  // Liquid 给的兜底档：需要超过 420 像素宽才用 ≤720p 那档
  const chooseVideoSrc = (it) => {
    const sd = it.media.dataset.srcSd || '';
    const hd = it.media.dataset.srcHd || sd;
    return neededWidth(it) > 420 ? hd : sd || hd;
  };

  // TH-QA-279：staging 实测 Liquid 的 video.sources 只有 m3u8 + 一档 1080p mp4（7.2Mbps），
  // 480p / 720p 只在店面产品 JSON（/products/<handle>.js）里。照 Liquid 那档挂，手机两列卡
  // 也在拉 1080p。所以挂源前按 media id 去产品 JSON 里挑：最小一档宽度 ≥ 需要的 80%
  // （cover 裁切、轻微放大看不出来），都不够就用最大那档。同一产品只请求一次；
  // 请求失败 / 404 / 找不到这条媒体就用 Liquid 那档，视频照样能播。
  const productRequests = new Map();
  const productJson = (handle) => {
    if (!productRequests.has(handle)) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      productRequests.set(handle, window.fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      }).then((res) => (res && res.ok ? res.json() : null)).catch(() => null));
    }
    return productRequests.get(handle);
  };
  const pickRendition = (sources, need) => {
    const mp4 = (Array.isArray(sources) ? sources : [])
      .filter((s) => s && s.format === 'mp4' && s.url && s.width > 0)
      .sort((a, b) => a.width - b.width);
    if (!mp4.length) return '';
    const fit = mp4.find((s) => s.width >= need * 0.8);
    return (fit || mp4[mp4.length - 1]).url;
  };
  function resolveVideoSrc(it) {
    const fallback = chooseVideoSrc(it);
    const mediaId = Number(it.media.dataset.mediaId);
    const handle = it.card && it.card.dataset.product;
    if (!mediaId || !handle || typeof window.fetch !== 'function') return Promise.resolve(fallback);
    return productJson(handle).then((product) => {
      const media = product && Array.isArray(product.media)
        ? product.media.find((m) => m && Number(m.id) === mediaId)
        : null;
      return (media && pickRendition(media.sources, neededWidth(it))) || fallback;
    }, () => fallback);
  }

  // 本次入场还能不能动
  const shouldRun = (it) =>
    allowed() && it.inView && !it.done && !it.hovered && !it.dismissed && !it.failed && !document.hidden;

  function fail(it) {
    it.failed = true;
    it.root.classList.remove('is-ready');
    if (!it.media.paused) it.media.pause();
  }

  // 这一遍播完（或被系统拒绝）：停下、淡回首图，直到下次重新进入视口
  function finish(it) {
    it.done = true;
    clearTimeout(it.stallTimer);
    it.stallTimer = null;
    it.root.classList.remove('is-ready');
    if (!it.media.paused) it.media.pause();
  }

  // 某些 iPhone 低电量模式会触发 playing，却不推进 currentTime。
  // 暂停/悬停/后台不计入冻结时间；正常推进或下一遍开始会重置观察窗口。
  function watchProgress(it) {
    clearTimeout(it.stallTimer);
    it.stallTimer = null;
    if (!shouldRun(it) || it.media.paused) return;
    const time = it.media.currentTime;
    it.stallTimer = setTimeout(() => {
      it.stallTimer = null;
      if (!shouldRun(it) || it.media.paused) return;
      if (it.media.currentTime === time) { finish(it); return; }
      watchProgress(it);
    }, STALL_MS);
  }

  function attach(it, src) {
    if (it.srcReady) return;
    if (!src) { fail(it); return; }
    it.media.src = src;
    it.srcReady = true;
  }

  function load(it) {
    if (it.loaded) return;
    it.loaded = true;
    const video = it.media;
    // 属性之外再设一次 property：有的浏览器判定「静音自动播放」只认 property
    video.muted = true;
    video.addEventListener('playing', () => {
      if (it.done || !shouldRun(it)) return;
      it.root.classList.add('is-ready');
      watchProgress(it);
    });
    // 完整播完才计一遍，0 不设次数上限；不按素材秒数截断。
    video.addEventListener('ended', () => {
      it.runs += 1;
      if (it.playCount > 0 && it.runs >= it.playCount) { finish(it); return; }
      if (!shouldRun(it)) return;
      video.currentTime = 0;
      const again = video.play();
      if (again && again.catch) again.catch((err) => {
        if (err && err.name === 'AbortError') return;
        if (video.paused) finish(it);
      });
    });
    video.addEventListener('error', () => fail(it));
    video.preload = 'metadata';
    resolveVideoSrc(it).then((src) => {
      // 等产品 JSON 期间卡片可能已被筛选 / 分页换掉
      if (!it.root.isConnected || it.failed) return;
      attach(it, src);
      sync(it);
    });
  }

  function sync(it) {
    const video = it.media;
    if (shouldRun(it)) {
      load(it);
      if (!it.srcReady) return;
      const played = video.play();
      if (played && played.catch) {
        played.catch((err) => {
          // AbortError = 刚 play() 就被 pause() 打断（滚出视口、悬停），属于正常竞态
          if (err && err.name === 'AbortError') return;
          if (video.paused) finish(it);
        });
      }
      return;
    }
    clearTimeout(it.stallTimer);
    it.stallTimer = null;
    if (!video.paused) video.pause();
    // 不在播放窗口里就别把停住的那一帧留在首图上
    if (!it.hovered) it.root.classList.remove('is-ready');
  }

  const syncAll = () => items.forEach(sync);

  // 重新进入视口：新的一遍，从头播
  function rearm(it) {
    if (it.dismissed || it.failed) return;
    it.done = false;
    it.runs = 0;
    clearTimeout(it.stallTimer);
    it.stallTimer = null;
    if (it.srcReady) {
      try { it.media.currentTime = 0; } catch (e) { /* 元数据未就绪时设不了，等于从头 */ }
    }
  }

  function dismiss(card) {
    if (!card) return;
    card.querySelectorAll(ROOT_SEL).forEach((root) => {
      const it = items.get(root);
      root.classList.add('is-dismissed');
      if (!it) return;
      it.dismissed = true;
      sync(it);
    });
  }

  function bind(root) {
    if (items.has(root)) return;
    // 只认视频层：已不支持 GIF，旧缓存 HTML 里若还有 GIF 层就当静态卡
    const media = root.querySelector('video.card-motion__media');
    if (!media) return;
    const card = root.closest('.card-wrapper');
    const it = {
      root,
      card,
      media,
      yields: root.classList.contains('card-motion--yields'),
      inView: false,
      hovered: false,
      loaded: false,
      srcReady: false,
      done: false,
      runs: 0,
      playCount: playCount(root.dataset.playCount),
      dismissed: false,
      failed: false,
      stallTimer: null,
    };
    items.set(root, it);

    if (it.yields && card) {
      card.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !hoverMQ.matches) return;
        it.hovered = true;
        sync(it);
      });
      card.addEventListener('pointerleave', () => {
        if (!it.hovered) return;
        it.hovered = false;
        sync(it);
      });
    }

    if (nearIO && viewIO) {
      nearIO.observe(root);
      viewIO.observe(root);
    } else {
      it.inView = true;
    }
    sync(it);
  }

  // 卡片被筛选 / 分页整块换掉：断开观察、停播、摘掉视频源释放连接
  function sweep() {
    items.forEach((it, root) => {
      if (root.isConnected) return;
      if (nearIO) nearIO.unobserve(root);
      if (viewIO) viewIO.unobserve(root);
      clearTimeout(it.stallTimer);
      if (!it.media.paused) it.media.pause();
      if (it.loaded) {
        it.media.removeAttribute('src');
        it.media.load();
      }
      items.delete(root);
    });
  }

  function scan(scope) {
    if (items.size) sweep();
    (scope || document).querySelectorAll(ROOT_SEL).forEach(bind);
  }

  if ('IntersectionObserver' in window) {
    nearIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const it = items.get(entry.target);
        if (it && entry.isIntersecting && allowed() && !it.dismissed) load(it);
      });
    }, { rootMargin: '300px 0px' });
    viewIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const it = items.get(entry.target);
        if (!it) return;
        const visible = entry.isIntersecting && entry.intersectionRatio >= 0.24;
        if (visible && !it.inView) rearm(it);
        it.inView = visible;
        sync(it);
      });
    }, { threshold: [0, 0.25] });
  }

  // 色块（旧版就地换图 / radio 色块）一旦被点，这张卡的动图撤掉。
  // 捕获阶段登记、不拦截：色块自己的跳转 / 换图逻辑照常进行。
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const swatch = target.closest('.colorItemBox, .js-color-swatches input');
    if (!swatch) return;
    let card = swatch.closest('.card-wrapper');
    if (!card) {
      // 旧 markup 下色块可能被甩出 .card-wrapper，按产品 handle 在同一个格子里找
      const list = swatch.closest('[data-product]');
      const handle = list && list.dataset.product;
      let scope = list && list.parentElement;
      for (let depth = 0; scope && handle && depth < 4 && !card; depth += 1, scope = scope.parentElement) {
        card = Array.prototype.find.call(scope.querySelectorAll('.card-wrapper'),
          (el) => el.dataset.product === handle && el.querySelector(ROOT_SEL));
      }
    }
    dismiss(card);
  }, true);

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(() => {
      scheduled = false;
      scan();
    });
  };
  if ('MutationObserver' in window) {
    new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes.length || mutations[i].removedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('visibilitychange', syncAll);
  // 会话中途打开系统「减少动效」：正在播的立即停
  if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', syncAll);
  else if (reduceMQ.addListener) reduceMQ.addListener(syncAll);

  window.themeCardMotion = { scan, items };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }
})();
